<template>
  <div>
    <label v-if="label && label !== ''" class="small" for="backgroundPropertiesSelects">{{ label }}</label>
    <div class="mb-3">
      <label>Couleur de fond</label>
      <InputColorPicker Label="Couleur du fond" v-model="backgroundColor" />
    </div>
    <div class="row mb-2" id="backgroundPropertiesSelects">
      <div class="col pe-0">
        <input v-model="thickness" type="number" class="form-control" id="borderThickness">
      </div>
      <div class="col px-1">
        <select class="form-control" v-model="style">
          <option value="none">None</option>
          <option value="dotted">dotted</option>
          <option value="dashed">dashed</option>
          <option value="solid">solid</option>
          <option value="double">double</option>
          <option value="groove">groove</option>
          <option value="ridge">ridge</option>
          <option value="inset">inset</option>
          <option value="outset">outset</option>
        </select>
      </div>
      <div class="col ps-0">
        <InputColorPicker
          v-model="color" />
      </div>
    </div>
    <div>
      <label class='small'>Border Radius</label>
      <vue-slider class="mt-2 ms-2" :min="0" :max="100" v-model="radius" />
    </div>
  </div>
</template>

<script>

import VueSlider from 'vue-slider-component';
import InputColorPicker from './InputColorPicker.vue';

export default {
  name: 'BorderEditor',
  components: {
    InputColorPicker,
    VueSlider,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    label: {
      type: String,
      required: false,
      default: '',
    },
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    backgroundColor: {
      get()
      {
        return this.value.backgroundColor || {};
      },
      set(newBackgroundColor)
      {
        this.$emit('change', { ...this.value, backgroundColor: newBackgroundColor });
      },
    },
    thickness: {
      get()
      {
        return this.value.thickness || 0;
      },
      set(thickness)
      {
        this.$emit('change', { ...this.value, thickness });
      },
    },
    style: {
      get()
      {
        return this.value.style || 'none';
      },
      set(style)
      {
        this.$emit('change', { ...this.value, style });
      },
    },
    color: {
      get()
      {
        return this.value.color || {};
      },
      set(color)
      {
        this.$emit('change', { ...this.value, color });
      },
    },
    radius: {
      get()
      {
        return this.value.radius || 0;
      },
      set(newRadius)
      {
        this.$emit('change', { ...this.value, radius: newRadius });
      },
    },
  },
};

</script>

<style scoped>

</style>
